import { CardUIExtension, ICardUIExtensionContext } from 'tessa/ui/cards';
import { FileListViewModel } from 'tessa/ui/cards/controls';
import { CdCardTypes } from '../Helpers/CdCardTypes';
import { CdApprovalListHelper } from '../Helpers/CdApprovalListHelper';
import { CdIncomingTaskHistoryHelper } from '../Helpers/CdIncomingTaskHistoryHelper';
import { CdRdListHelper } from '../Helpers/CdRdListHelper';
import { PkCardTypes } from 'src/pkScripts/Helpers/PkCardTypes';


export class CdApprovalListUIExtension extends CardUIExtension {

  public initialized(context: ICardUIExtensionContext) {
    if (context.model == null ||
        context.model.card == null) {
      return;
    }
    if (!(CdCardTypes.TypesOfDocumentsWithApprovalLists.indexOf(context.model.card.typeId) > -1) &&
        !(PkCardTypes.TypesOfDocumentsWithApprovalLists.indexOf(context.model.card.typeId) > -1)) {
      return;
    }

    let filesFileControl = context.model.controls.get('Files') as FileListViewModel;
    let approvalListFileControl = context.model.controls.get('FilesAdditional') as FileListViewModel;

    if (filesFileControl == null || approvalListFileControl == null) {
        return;
    }
    approvalListFileControl.groupsExpanded = true;
    approvalListFileControl.isCategoriesEnabled = false;

    // показываем файлы все кроме листов согласование
    for (let i = filesFileControl.files.length - 1; i > -1; i--) {
      const file = filesFileControl.files[i];
      if (file.model.name != null &&
        (file.model.name === CdApprovalListHelper.ApprovalListFileName ||
          file.model.name === CdApprovalListHelper.AcquaintanceListFileName) ||
          file.model.name === CdIncomingTaskHistoryHelper.IncomingTaskHistoryListFileName ||
          file.model.name === CdRdListHelper.RdListFileName ||
          (context.model.card.typeId == CdCardTypes.ArContractTypeID && file.model.name === "История.html")
          ) {
        filesFileControl.removeFile(file);
      }
    }       

    // показываем только листы согласования
    for (let i = approvalListFileControl.files.length - 1; i > -1; i--) {
      const file = approvalListFileControl.files[i];
      if (!(file.model.name != null &&
        (file.model.name === CdApprovalListHelper.ApprovalListFileName ||
          file.model.name === CdApprovalListHelper.AcquaintanceListFileName) ||
          file.model.name === CdIncomingTaskHistoryHelper.IncomingTaskHistoryListFileName)) {
          approvalListFileControl.removeFile(file);
      }
    } 
  }
}